import {
  takeLatest, select, call,
} from 'redux-saga/effects';
import { api } from '@/utils/api';
import { config } from '@/config';
import { isBRServer } from '@/utils/Validators/validation';
import logger from '@/utils/logger';
import { MerlinActionTypes } from '@/redux/modules/merlin/merlin.types';
import { put } from 'redux-saga-test-plan/matchers';
import { merlinActions } from '@/redux/modules';

const { WHMCS_URL } = config;

function* requestMerlinToken() {
  const { token, jwt: jwtToken } = yield select(state => state.auth);
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: `${WHMCS_URL}/api/v3/ai-agents/generate-token`,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-service-token': jwtToken,
      brand,
    },
  };
  try {
    const response = yield call(api.whmcs.get, request);
    yield put(merlinActions.merlinTokenSuccess(response.data.data.token));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    yield put(merlinActions.merlinTokenFail());
    logger.error('Error sagas requestMerlinToken', error);
  }
}

function* sagas() {
  yield takeLatest(MerlinActionTypes.MERLIN_GENERATE_TOKEN, requestMerlinToken);
}

export default sagas;
